import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 数据表格列表页
 * @param vCom Vue组件
 * @param params 查询列表需要的参数
 */
const GetDataTables = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/data/tables", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 数据筛选时获取右侧列项树形列表
 * @overview 创建数据表格-添加研究指标：模板列表
 * @param vCom Vue组件
 * @param groupId 分组id
 */
const GetColumnTreeTemplates = (vCom: any, groupId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                group_id: groupId
            }
        };
        axios.get("api/data/table/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 创建数据表格
 * @param vCom Vue组件
 * @param params 生成数据表格需要的参数
 */
const PostCreateDataTable = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/data/table", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 预览数据表格
 * @param vCom Vue组件
 * @param tableId 表格id
 */
const GetDataTableReview = (vCom: any, tableId: any): Promise<any> => {
    const params: any = {
        params: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/data/table", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 删除数据表格
 * @param vCom Vue组件
 * @param tableId 表格id
 */
const DeleteDataTable = (vCom: any, tableId: any): Promise<any> => {
    const params: any = {
        data: {
            table_id: tableId
        }
    };
    return new Promise((resolve, reject) => {
        axios.delete("api/data/table", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 导出数据表格
 * @param vCom Vue组件
 * @param tableId 表格id
 */
const PostExportDataTable = (vCom: any, tableId: any): Promise<any> => {
    const params: any = {
        table_id: tableId
    };
    return new Promise((resolve, reject) => {
        axios.post("api/data/export/table", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 下载数据表格
 * @param vCom Vue组件
 * @param tableId 表格id
 */
const GetExportDataTable = (filename: any) => {
    window.open(window.API_ROOT + "api/wajue/download?filename=" + filename);
};



export { GetDataTables, GetColumnTreeTemplates, PostCreateDataTable, GetDataTableReview, DeleteDataTable, PostExportDataTable, GetExportDataTable };


